import axios from 'axios';
import { serverName } from '../config';
import { store } from '../store/configureStore';
import { clearUser } from '../store/interfaceSlice';

const instance = axios.create({
  baseURL: serverName === '' ? undefined : (serverName || 'https://findmarks.ru'),
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      localStorage.removeItem('token');
      try {
        store.dispatch(clearUser());
      } catch {
        /* ignore */
      }
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('auth:unauthorized'));
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
